export default __webpack_public_path__ + "static/media/Bot-Work-In-Progress-1.1ab6453d.jpg";